import { selectLayout, setTheme, THEME } from '@src/store/layout/layoutSlice';
import { Moon, Sun1 } from 'iconsax-react';
import { useDispatch, useSelector } from 'react-redux';

export function ThemeToggle() {
  const dispatch = useDispatch();
  const layout = useSelector(selectLayout);
  const isDark = layout.theme == THEME.DARK;

  const toggleTheme = () => {
    const selectedTheme =
      layout.theme === THEME.LIGHT ? THEME.DARK : THEME.LIGHT;
    dispatch(setTheme(selectedTheme));
    document.documentElement.classList.toggle(
      'dark',
      selectedTheme === THEME.DARK
    );
  };

  return (
    <button
      onClick={toggleTheme}
      className={`w-14 h-8 rounded-full flex items-center px-1 transition-colors duration-300 ${
        isDark ? 'bg-gray-800' : 'bg-white'
      }`}
    >
      <div
        className={`w-6 h-6 rounded-full ${isDark ? 'bg-gray-700' : 'bg-gray-200'}  flex items-center justify-center transition-transform duration-300 transform ${
          isDark ? 'translate-x-0' : 'translate-x-6'
        }`}
      >
        {isDark ? (
          <Sun1 size={32} variant='Bold' className='text-yellow-500' />
        ) : (
          <Moon size={32} variant='Bold' className='text-wl-primary' />
        )}
      </div>
    </button>
  );
}
